import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";
import axiosInstance from "../api/axiosInstance";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { baseurl } from "../Baseurl";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function BArchart() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getFontSize = () => {
    if (windowWidth > 3000) return 24;
    if (windowWidth > 2500) return 19;
    if (windowWidth >= 2000) return 15;
    if (windowWidth >= 1600) return 13;
    return 11;
  };
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [chartData, setChartData] = useState({
    labels: ["Loading..."],
    datasets: [
      {
        label: "Lab Requests",
        data: [0],
        backgroundColor: "#9B5DE0",
        borderColor: "#9B5DE0",
        borderWidth: 1,
      },
    ],
  });

  const [loading, setLoading] = useState(true);

  const fetchChartData = async () => {
    try {
      const res = await axiosInstance.get(`dashboard/lab_request_stats`);

      if (res.status === 200 && res.data.success && res.data.data?.length) {
        const data = res.data.data;

        setChartData({
          labels: data.map((item) =>
            item.labs?.length > 15 ? item.labs.slice(0, 15) + "..." : item.labs ?? "N/A"
          ),
          datasets: [
            {
              label: "Lab Requests",
              data: data.map((item) => item.total_requests ?? 0),
              backgroundColor: "rgba(155, 93, 224, 0.7)",
              borderColor: "#9B5DE0",
              borderWidth: 1,
            },
          ],
        });
      } else {
        console.warn("API returned no data, keeping defaults.");
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChartData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: {
          color: "#333",
          font: {
            size: getFontSize(), // ✅ Dynamic legend font size
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y}`,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#333",
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          font: {
            size: getFontSize(), // ✅ X-axis labels font
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        min: 0,
        ticks: {
          color: "#333",
          stepSize: 5,
          font: {
            size: getFontSize(), // ✅ Y-axis labels font
          },
        },
        grid: {
          color: "rgba(200, 200, 200, 0.3)",
        },
      },
    },
  };

  return (

    <div style={{ width: "100%", margin: "0 auto", height: "85%" }} className="chartFull" >
      {loading ? (
        <p>Loading chart...</p>
      ) : (
        <Bar data={chartData} options={options} key={windowWidth} />
      )}
    </div>

  );
}
